<div
  class="container-fluid container-checkout"
  *ngIf="cartData$ | async as cart; else loading"
>
  <div class="row">
    <div class="col-md-12">
      <div class="row mb5 m-t-20">
        <div class="col-md-7"></div>
        <div class="col-md-5 text-right text-btn">
          <p class="m-b-5 m-r-15">
            <span class="header" *ngIf="cart?.totalItems <= 1"
              >{{ "quoteCheckout.cartTotal" | cxTranslate }} ( {{ cart?.totalItems }} item):
            </span>
            <span class="header" *ngIf="cart?.totalItems > 1"
              >{{ "quoteCheckout.cartTotal" | cxTranslate }} ( {{ cart?.totalItems }} items):
            </span>
            <span class="bold"> {{ "quoteCheckout.toBeQuoted" | cxTranslate }} </span>
          </p>
          <button
            (click)="onQuoteReview()"
            class="vs-primary-btn checkoutBtn"
            [disabled]="isDisabled || checkoutBtnDisable()"
          >
          {{ "quoteCheckout.continueCheckout" | cxTranslate }}
          </button>
          <!-- <span class="block-user-error" *ngIf="userSapBlocked">
            <i class="material-icons">warning</i>
            <span class="error-message">
              {{"orderCheckOut.actionBlocked" | cxTranslate}}
              <a href="/contactus" class="contact-us">Customer care</a>
            </span>
          </span> -->
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="orderGroup">
    <div class="row">
      <div class="col-md-3">
        <div class="vs-text-field">
          <label>{{ "quoteCheckout.quoteReference" | cxTranslate }}</label>
          <input
            class="customer-reference"
            type="text"
            maxlength="35"
            placeholder='{{ "quoteCheckout.customerProjectName" | cxTranslate }}'
            formControlName="projectName"
          />
        </div>
      </div>
    <div class="col-md-3"> 
          <div *ngIf="orderTypeData$ | async as rfqOrderType">
            <label
              ><span class="star">* </span
              ><span class="label-custom">{{ "quoteCheckout.orderType" | cxTranslate }}</span>
            </label>
            <div>
              {{cartData?.rfqType === "RSL" ? "Resale" : "Stock"}}
            </div>
    <!-- This Order Type section commented on Bussines Requirements By default (OrderType = Resale) -->
            <!-- <ng-select
              #orderTypeFocus
              [searchable]="false"
              [clearable]="false"
              [ngClass]="
                orderGroup.controls.orderType.invalid && isSubmitted
                  ? 'error-select'
                  : ''
              "
              placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
              (change)="orderChange()"
              formControlName="orderType"
            >
              <ng-option
                *ngFor="let order of rfqOrderType.orderType"
                [value]="order.code"
                >{{ order.name }}</ng-option
              >
            </ng-select>
            <label
              *ngIf="orderGroup.controls.orderType.invalid && isSubmitted"
              class="error"
              >{{ "quoteCheckout.orderError" | cxTranslate }}
            </label>  -->
          </div>
        </div> 
    </div>
  </div>
  <div *ngIf="isLoggedinUser">
    <vs-loggedIn-user-checkout
      [orderType]="orderGroup.value.orderType"
      [orderChanged]="orderChanged"
      (getContactNumber)="getContactNumber($event)"
      [isSubmitted]="isSubmitted"
      [cartData]="cart"
      (updateFile)="updateFile($event)"
      [rfqTypes]="rfqTypes"
      (cartUpdate)="cartUpdate($event)"
    ></vs-loggedIn-user-checkout>
  </div>
  <div *ngIf="!isLoggedinUser" class="mb-42">
    <vs-guest-checkout
      [orderType]="orderGroup.value.orderType"
      (getNotificationEmail)="getNotificationEmail($event)"
      [orderChanged]="orderChanged"
      [isSubmitted]="isSubmitted"
      [count]="count"
      (getContactNumber)="getContactNumber($event)"
      [cartData]="cart"
      [rfqTypes]="rfqTypes"
      (updateFile)="updateFile($event)"
      (cartUpdate)="cartUpdate($event)"
    ></vs-guest-checkout>
  </div>

  <div class="row mb-25">
    <div class="col-md-12">
      <div class="row mb5 m-t-20">
        <div class="col-md-7"></div>
        <div class="col-md-5 text-right text-btn">
          <p class="m-b-5 m-r-15">
            <span class="header" *ngIf="cart?.totalItems <= 1"
              >{{ "quoteCheckout.cartTotal" | cxTranslate }}  ( {{ cart?.totalItems }} item):
            </span>
            <span class="header" *ngIf="cart?.totalItems > 1"
              >{{ "quoteCheckout.cartTotal" | cxTranslate }}  ( {{ cart?.totalItems }} items):
            </span>
            <span class="bold"> {{ "quoteCheckout.toBeQuoted" | cxTranslate }}  </span>
          </p>
          <button
            (click)="onQuoteReview()"
            class="vs-primary-btn checkoutBtn"
            [disabled]="isDisabled || checkoutBtnDisable()"
          >
          {{ "quoteCheckout.continueCheckout" | cxTranslate }}
          </button>
          <!-- <span class="block-user-error" *ngIf="userSapBlocked">
            <i class="material-icons">warning</i>
            <span class="error-message">
              {{"orderCheckOut.actionBlocked" | cxTranslate}}
              <a href="/contactus" class="contact-us">Customer care</a>
            </span>
          </span> -->
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
